<template>
  <div>
    <h1>404</h1>
    <h2>您访问的页面不存在！</h2>
  </div>
</template>

<script>
export default {
  name: "AccessDenied",
  data() {
    return {};
  },
  created() {},
  destroyed(){
    location.reload()
  },
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,h2{
  color: rgb(22, 20, 51);
}
h1{
  width: 100%;
  display: block;
  font-size: 100px;
  text-align: center;
  border-bottom: 1px solid #000;
}
h2{
  width: 100%;
  display: block;
  font-size: 50px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/AccessDenied/index.vue